import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'homepage',
  `
    CHANGE_APP_SEARCH_QUERY

    SELECT_SERVICE_SEARCH_SERVICE
  `
);
